import {
  Box,
  Container,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
} from "@chakra-ui/react";
import { useEffect } from "react";
import { useHistory  } from "react-router-dom";
import Login from "../components/Authentication/Login";
import Signup from "../components/Authentication/Signup";


function Homepage() {
  const history = useHistory();

  useEffect(() => {
    if(history.location.pathname!='/inscription')
    {
    const user = JSON.parse(localStorage.getItem("userInfo"));

    if (user) history.push("/student");
    }
  }, [history]);

  return (
    <Container maxW="xl" m={'auto'} centerContent>
     
      <Box bg="white" w="80%" px={4} borderRadius="lg" borderWidth="1px">
        <Tabs isFitted variant="soft-rounded">
          <TabList mb="1em">
            {/* <Tab>Login</Tab> */}
            {/* <Tab>Sign Up</Tab> */}
          </TabList>
          <TabPanels>
            <TabPanel>
              <Login />
            </TabPanel>
            <TabPanel>
              {/* <Signup /> */}
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Box>
    </Container>
  );
}

export default Homepage;
